var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { encryptedAccodeVer1 } from "@domains/utils/encryption";
import { getDateInFormat } from "@domains/utils/reportDates";
import { accountDetails } from "@salesdi";
import config from "@frameworks/salesjourney/config/domain";
import React, { useEffect, useState } from "react";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import { useSelector } from "react-redux";
var ServiceRequestData = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var _s = __read(useState(), 2), redirectUrl = _s[0], setRedirectUrl = _s[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var redirect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, accountDetails.getSalesAuthToken()];
                case 1:
                    token = _b.sent();
                    setRedirectUrl("".concat(process.env.CUSTOMER_SERVICE_LOGIN, "?Token=").concat(token, "&redirect=").concat(config.customerServiceRedirect, "/").concat(encryptedAccodeVer1(selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode), "/").concat((_a = props.data) === null || _a === void 0 ? void 0 : _a.ServiceRequestID));
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        redirect();
    }, []);
    return (React.createElement("div", { className: "d-grid sr" },
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Service Request Id"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1 text-decoration-underline" },
                React.createElement("a", { target: "_blank", href: redirectUrl, className: "txt_blackOne1" }, (_a = props.data) === null || _a === void 0 ? void 0 : _a.ServiceRequestID))),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Account Code"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_b = props.data) === null || _b === void 0 ? void 0 : _b.AcCode)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Client Name"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_c = props.data) === null || _c === void 0 ? void 0 : _c.AcName)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Client Tire"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_d = props.data) === null || _d === void 0 ? void 0 : _d.ClientTier)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Category"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_e = props.data) === null || _e === void 0 ? void 0 : _e.CategoryName)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Call Type"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1 text-decoration-underline" }, (_f = props.data) === null || _f === void 0 ? void 0 : _f.CallTypeName)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Sub Type"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_g = props.data) === null || _g === void 0 ? void 0 : _g.SubTypeName)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Assigned Team"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_h = props.data) === null || _h === void 0 ? void 0 : _h.AssignTeamName)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Assigned User"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_j = props === null || props === void 0 ? void 0 : props.data) === null || _j === void 0 ? void 0 : _j.AssinIndividualName)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Status"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_k = props.data) === null || _k === void 0 ? void 0 : _k.Status)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Created User"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, (_l = props.data) === null || _l === void 0 ? void 0 : _l.CreatedUser)),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Created Date"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, getDateInFormat((_m = props.data) === null || _m === void 0 ? void 0 : _m.CreatedDate, "DD MMM yyyy"))),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Closed Date"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, getDateInFormat((_o = props.data) === null || _o === void 0 ? void 0 : _o.AssignDate, "DD MMM yyyy"))),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Due Date"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, getDateInFormat((_p = props.data) === null || _p === void 0 ? void 0 : _p.DueDate, "DD MMM yyyy"))),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Process Time"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, addDashIfNullOrUndefined((_q = props.data) === null || _q === void 0 ? void 0 : _q.TimeTaken))),
        React.createElement("div", null,
            React.createElement("label", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "Jira Ticket Id"),
            React.createElement("div", { className: "DMSanN_14_400 txt_blackOne1" }, addDashIfNullOrUndefined((_r = props === null || props === void 0 ? void 0 : props.data) === null || _r === void 0 ? void 0 : _r.TicketID)))));
};
export default ServiceRequestData;
